/**
 * WELCOME BACK — the one-time notice after a sign-in that brought a deleted account back (OD-054, Terms §6: the profile
 * and the credits are restored, friends and messages are not). The shared popup with the approved sentence flow (Codex
 * order-popup-vertical-flow-v1); the server says `restored` on the sign-in answer or `?restored=1` on the redirect.
 */
import { art } from '../art';
import { PopupPanel } from './PopupPanel';
import { welcomeBack } from '../state/store';
import { sfx } from '../audio/sfx';

export function WelcomeBack() {
  const close = () => { sfx.tap(); welcomeBack.value = false; };
  return (
    <div class="sheet-backdrop od-scrim" onClick={close} data-testid="welcome-back">
      <PopupPanel title="WELCOME BACK" label="Welcome back" onClose={close} closeTestid="welcome-back-close" testid="welcome-back-popup" cls="od-pop">
        <div class="od-flow">
          <p class="od-line od-first">Your profile and credits are back.</p>
          <p class="od-soft">Friends and messages were not restored.</p>
          <button class="od-btn od-gold" type="button" data-testid="welcome-back-ok" style={{ '--plate': `url(${art('/art/lobby-kit/cta.plate.png')})` }} onClick={close}><span>OK</span></button>
        </div>
      </PopupPanel>
    </div>
  );
}
